import React from 'react';
import { SocialCss } from './social.css';
import { FaFacebookSquare, FaTwitterSquare, FaLinkedin } from 'react-icons/fa';

const Socialmedia = () => {
  return (
    <SocialCss>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.facebook.com/PTCTherapeutics/"
      >
        <FaFacebookSquare className={'social-logo'} />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://twitter.com/PTCBio"
      >
        <FaTwitterSquare className={'social-logo'} />
      </a>
      <a
        target="_blank"
        rel="noopener noreferrer"
        href="https://www.linkedin.com/company/ptc-therapeutics"
      >
        <FaLinkedin className={'social-logo'} />
      </a>
    </SocialCss>
  );
};

export default Socialmedia;
